<mat-label>{{dropdownData.title}}</mat-label>
<ng-select [multiple]="true" [virtualScroll]="true" (change)="chosenOptions()" [(ngModel)]="selectedValues">
  <ng-option *ngFor="let item of dropdownData.values" [value]="item">{{item}}</ng-option>
</ng-select>
